import axios from 'axios';

/*
 * Minimal axios instance for the growth endpoints. Kept separate from the main
 * services/api.js (owned elsewhere) but mirrors its auth behavior: pull the bearer
 * token from the parsed `user` object in localStorage, falling back to the legacy
 * `token` key.
 */
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const growthApi = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
  timeout: 30000,
});

growthApi.interceptors.request.use(
  (config) => {
    // Prefer the token stored on the user object (set by the auth service).
    let token = null;
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        token = JSON.parse(userStr).token;
      } catch (e) {
        // ignore malformed user blob; fall through to legacy token
      }
    }
    if (!token) token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export const getReferral = () => growthApi.get('/api/growth/referral');
export const refer = (email) => growthApi.post('/api/growth/refer', { email });

export default growthApi;
